// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2fhDw","label":"Category_label__1psNZ","content":"Category_content__1Ubwn","header":"Category_header__3iWIN","location":"Category_location__34ZYu"};